module.exports = __webpack_public_path__ + "static/media/heart.bd10beef.svg";